import React, { useState } from "react";
import { createPortal } from "react-dom";
import { X, CreditCard, Loader2, ShieldCheck } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export function extractWafidReportId(link) {
  const m = (link || "").match(/appointment\/([A-Za-z0-9]+)\/pay/);
  return m ? m[1] : null;
}

export default function WafidPayDialog({ link, buttonClassName = "", buttonTestId = "pay-wafid-btn", onClose }) {
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const reportId = extractWafidReportId(link);

  if (!reportId) return null;

  const close = () => {
    setOpen(false);
    setLoaded(false);
    if (onClose) onClose();
  };

  return (
    <>
      <button
        type="button"
        data-testid={buttonTestId}
        onClick={() => setOpen(true)}
        className={buttonClassName || "inline-flex items-center gap-1.5 text-sm font-bold text-white bg-[var(--brand-primary)] hover:bg-[#9E855A] rounded-full px-6 py-2.5 transition-colors"}
      >
        Pay to Wafid <CreditCard size={14} />
      </button>
      {open && createPortal(
        <div data-testid="wafid-pay-modal" className="fixed inset-0 z-[200] flex items-center justify-center bg-black/60 p-2 sm:p-4">
          <div className="relative flex w-full max-w-4xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl" style={{ height: "92vh" }}>
            <div className="flex items-center justify-between gap-3 border-b border-[#E5DFD3] bg-[#FBF9F4] px-4 py-2.5">
              <div className="flex items-center gap-2 text-sm font-bold text-[#1A1A1A]">
                <ShieldCheck size={16} className="text-green-600" />
                Secure Wafid Payment
              </div>
              <button
                type="button"
                data-testid="wafid-pay-close-btn"
                onClick={close}
                className="flex h-8 w-8 items-center justify-center rounded-full bg-white border border-[#E5DFD3] text-[#6a6a6a] hover:bg-[#f2eee4] transition-colors"
              >
                <X size={16} />
              </button>
            </div>
            <div className="relative flex-1 bg-white">
              {!loaded && (
                <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-white">
                  <Loader2 size={28} className="animate-spin text-[#b1976b]" />
                  <p className="text-sm text-[#8a8a8a]">Loading secure payment page…</p>
                </div>
              )}
              <iframe
                data-testid="wafid-pay-iframe"
                title="Wafid Payment"
                src={`${API}/api/gamca/pay-frame/${reportId}`}
                onLoad={() => setLoaded(true)}
                allow="payment *"
                className="h-full w-full border-0"
              />
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
}
